import React from 'react';
import { useDispatch } from 'react-redux';

import type { MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';
import { ResponsiveDialog, useFilters, useSettings, useUserData, Utils } from 'app/main/components';
import AddRowsFilterDialog from 'app/main/modules/components/AddRowsFilterDialog';

import DemsRecipientsAddResultDialog from './DemsRecipientsAddResultDialog';

interface DemsRecipientsAddFilterDialogProps {
	openDialog: boolean;
	switchOpenDialog: VoidFunction;
	demsUid: string;
	table: string;
	defaultFilters: MiddlewhereFilter[];
	updateRefresh: VoidFunction;
}

export default function DemsRecipientsAddFilterDialog(props: DemsRecipientsAddFilterDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const userData = useUserData();

	const filterProps = useFilters({ module: props.table, defaultFilters: props.defaultFilters });

	const [showResultsDialog, setShowResultsDialog] = React.useState(false);

	const closeDialog = () => {
		filterProps.handleFiltersClear();
		setShowResultsDialog(false);
		props.switchOpenDialog();
	};

	const showResults = () => {
		filterProps.handleFiltersApply();
		setShowResultsDialog(true);
	};

	const addRows = () => {
		Utils.executeStored({
			action: 'st_dems_recipients_add_multiple',
			dispatch,
			data: {
				derc_dems_uid: props.demsUid,
				derc_user_created_uid: userData.user_uid,
				filters: filterProps.filters
			},
			successHandler: () => {
				dispatch(Utils.alertSuccessMsg(t));
				closeDialog();
				props.updateRefresh();
			}
		});
	};

	return (
		<ResponsiveDialog open={props.openDialog} onClose={props.switchOpenDialog} maxWidth="lg" scroll="body">
			{!showResultsDialog ? (
				<AddRowsFilterDialog
					title={t(`DEMS_SECTION_ADD_${props.table}_TITLE`)}
					module={props.table}
					defaultFilters={filterProps.defaultFilters}
					currentFilters={filterProps.currentFilters}
					setCurrentFilters={filterProps.setCurrentFilters}
					handleFilterChange={filterProps.handleFilterChange}
					showResults={showResults}
					closeDialog={closeDialog}
				/>
			) : (
				<DemsRecipientsAddResultDialog
					defaultFilters={filterProps.filters}
					addRows={addRows}
					goBack={() => setShowResultsDialog(false)}
				/>
			)}
		</ResponsiveDialog>
	);
}
